import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import bssiLogo from "../../assets/images/bssi_logo_light.png";
import "./index.css";

export interface HeaderBarProps {
    name?: string;
    hideAuthentication?: boolean;
}

const HeaderBar = ({ name, hideAuthentication }: HeaderBarProps) => {
    const navigate = useNavigate();

    // Pull from your new AuthContext
    const { isAuthenticating, isAuthenticated, signOut } = useAuth();

    // Decide the label shown on the right side
    const authText = isAuthenticating ? "Logging in..." : isAuthenticated ? "Logout" : "Login";

    // Decide what happens when the user clicks the auth text
    const handleAuthClick = () => {
        if (isAuthenticating) return; // Do nothing if mid-auth

        if (isAuthenticated) {
            // User is logged in, so call signOut
            signOut();
        } else {
            // User is not logged in, navigate to sign-in ("/" in your current setup)
            navigate("/");
        }
    };

    return (
        <Box className="header-container">
            <Box className="left-items">
                <Box>
                    <img className="bssi-logo" onClick={() => navigate("/")} src={bssiLogo} alt="BSSI logo" />
                </Box>
            </Box>

            <Box className="middle-items">
                <Box className="header-text">{name || "Admin Console"}</Box>
            </Box>

            <Box className="right-items">
                {!hideAuthentication && (
                    <Box className="header-text auth-text" onClick={handleAuthClick}>
                        {authText}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default HeaderBar;
